import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './utils/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

/* pages */
import AdminDashboard from './pages/AdminDashboard';
import ManagerDashboard from './pages/ManagerDashboard';
import VendorDashboard from './pages/VendorDashboard';
import PanelistDashboard from './pages/PanelistDashboard';
import Landing from './pages/Landing';
import CombinedLandingLogin from './pages/CombinedLandingLogin';

export default function App() {
  // Auto-detect subpath when hosted under a prefix like /talentmesh
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';
  const publicUrlPath = (process.env.PUBLIC_URL && new URL(process.env.PUBLIC_URL, window.location.origin).pathname) || '/';
  const baseName = currentPath.startsWith('/talentmesh') ? '/talentmesh' : publicUrlPath;
  return (
    <Router basename={baseName}>
      <AuthProvider>
        <Routes>
          {/* Public */}
          <Route path="/" element={<CombinedLandingLogin />} />
          <Route path="/login" element={<CombinedLandingLogin />} />

          {/* Admin */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Hiring Manager */}
          <Route
            path="/manager/dashboard"
            element={
              <ProtectedRoute allowedRoles={['manager']}>
                <ManagerDashboard />
              </ProtectedRoute>
            }
          />

          {/* Vendor */}
          <Route
            path="/vendor/dashboard"
            element={
              <ProtectedRoute allowedRoles={['vendor']}>
                <VendorDashboard />
              </ProtectedRoute>
            }
          />

          {/* Panelist */}
          <Route
            path="/panelist/dashboard"
            element={
              <ProtectedRoute allowedRoles={['panelist']}>
                <PanelistDashboard />
              </ProtectedRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}
